import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

function NRJiraTicketStatusFormatter({ value }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: theme.spacing(1.25),
        py: theme.spacing(0.25),
        borderRadius: theme.spacing(2),
        border: `1px solid ${theme.palette.divider}`,
        maxWidth: '100%'
      }}
    >
      <Typography variant="body2" color="text.secondary" noWrap>
        {value}
      </Typography>
    </Box>
  );
}

export function NRJiraTicketStatusProvider(props) {
  return <DataTypeProvider formatterComponent={NRJiraTicketStatusFormatter} {...props} />;
}
